import { graphql } from 'relay-runtime';

export const CREATE_PROFILE_FORM_MUTATION = graphql`
  mutation EditProfileFormMutation($input: UnifiedProfileInput!) {
    unified {
      updateUnifiedProfile(unifiedProfileInput: $input) {
        errors {
          message
          extensions {
            errorType
            statusCode
          }
        }
        success
        unifiedProfile {
          company
          bio
          id
          aaid
          linkedinUrl
          location
          accountInternalId
          products
          role
          username
          internalId
          websiteUrl
          xUrl
          youtubeUrl
          isPrivate
        }
      }
    }
  }
`;
